export default __webpack_public_path__ + "static/media/optimize-your-website-content-for-maximum-conversion.851e68c1.png";